import { render, staticRenderFns } from "./SegmentListCreateOrEditBooleanFilter.vue?vue&type=template&id=8844f9e6&scoped=true&"
import script from "./SegmentListCreateOrEditBooleanFilter.vue?vue&type=script&lang=js&"
export * from "./SegmentListCreateOrEditBooleanFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8844f9e6",
  null
  
)

export default component.exports